import EtablissementMail from '@/generated/controls/etablissement/EtablissementMail.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementMail
})
